import React from "react";

import { t } from "../../../../../helpers/translator";

export const goldenRaceSinglesColumnConfig = () => {
	const { currency } = JSON.parse(sessionStorage.getItem("authData"));

	return [
		// {
		//     name: () => <>
		//         <label className={`ticket-container-check`}>
		//             <input
		//                 className='input-check'
		//                 type="checkbox"
		//                 checked={this.sportTickets.filter(item => item.isActive).every(item => item.isChecked)}
		//                 onChange={() => this.toggleAllSportTickets()}
		//             />
		//             <span className="checkmark">
		//             </span>
		//         </label>
		//         {t("Bet")} ({this.sportTickets.length})
		//     </>,
		//     row: item => {
		//         const checkedItem = checked[item.barcode];

		//         const isLoading = this.state.isLoading && checkedItem && !checkedItem.enableRemoveCounter;
		//         const isEarlyCashouted = item.cashout_amount && (earlyCashoutedBets?.[item.barcode] || earlyCashout?.[item.barcode]);
		//         const ticketState = getTicketState(item);
		//         const checkboxDisabled = disabledStates.includes(ticketState) || isEarlyCashouted || paiedTickets?.[item.barcode];

		//         return <>
		//             {isLoading && <div className="sk-chase">
		//                 <div className="sk-chase-dot" />
		//                 <div className="sk-chase-dot" />
		//                 <div className="sk-chase-dot" />
		//                 <div className="sk-chase-dot" />
		//                 <div className="sk-chase-dot" />
		//                 <div className="sk-chase-dot" />
		//             </div>}
		//             {!isLoading && ticketState === BetStateEnum.Accepted && <button
		//                 className="tickets-refresh-button"
		//                 onClick={e => this.onRefreshClick(e, item.casino_barcode || item.barcode)}
		//             />}
		//             <label className={`ticket-container-check ${checkboxDisabled ? 'disabled' : ''}`}>
		//                 <input
		//                     className='input-check'
		//                     disabled={checkboxDisabled}
		//                     type="checkbox"
		//                     checked={!!checkedItem}
		//                     onChange={() => this.toggleTicket(item)}
		//                 />
		//                 <span className="checkmark">
		//                 </span>
		//             </label>
		//             <p>{t(BetStateViewEnum[ticketState] || item.bet_state_name)}</p>
		//             {checkedItem?.enableRemoveCounter && <span className="ticket-remove-counter">
		//                 {t("The ticket will be automatically removed after")}
		//                 &nbsp;
		//                 <CountDown
		//                     propsDefaultSecond={Config.ticketPopupRemoveCounterSeconds}
		//                     endOfWork={() => this.removeTicket(item.barcode)}
		//                 />
		//                 &nbsp;
		//                 {t("seconds")}
		//             </span>}
		//         </>;
		//     },
		// },
		{
			name: () => t("Status"),
			row: item => <p>{t(item.win_info?.status || item.status)}</p>,
		},
		{
			name: () => t("Type"),
			row: item => (
				<p>
					{t("Single")} {console.log(item.event, "event")}
				</p>
			),
		},
		{
			name: () => t("Amount"),
			row: item => (
				<p>
					{item.stake} {currency.toUpperCase()}
				</p>
			),
		},
		{
			name: () => t("Price"),
			row: item => <p>{item.oddValue || "-"}</p>,
		},
		{
			name: () => t("Won amount"),
			row: item => (
				<p className={`add-v-t`}>
					{parseFloat(item.win_info?.wonAmount || 0).toFixed(2)} {currency.toUpperCase()}
				</p>
			),
		},
	];
};
